document.addEventListener('DOMContentLoaded', function() {
    //Inicializar slider intro home
    var swiper = new Swiper('.slider-intro-home', {
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: ".slider-intro-home-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    });

    // Inicializar slider info productos
    var swiperInfoProducts = new Swiper('.slider-info-products', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 25,
        navigation: {
            nextEl: '.slider-info-products-next',
            prevEl: '.slider-info-products-prev'
        }
    });

    // Inicializar slider cards
    var swiperInfoCards = new Swiper('.slider-box-cards', {
        spaceBetween: 24,
        slidesPerView: "auto",
        pagination: {
            el: ".slider-box-cards-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.slider-box-cards-next',
            prevEl: '.slider-box-cards-prev'
        }
    });

    // Inicializar slider custom products
    var swiperCustom = new Swiper('.swiper-products-selected', {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        breakpoints: {
            750: {
                slidesPerView: 3,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.slider-products-selected-next',
            prevEl: '.slider-products-selected-prev'
        }
    });

    // Inicializar slider custom products
    var swiperCustom = new Swiper('.swiper-products-for-category-selected', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 24,
        breakpoints: {
            450: {
                slidesPerView: 2,
                spaceBetween: 28,
            },
            750: {
                slidesPerView: 3,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.swiper-products-for-category-selected-next',
            prevEl: '.swiper-products-for-category-selected-prev'
        }
    });

    // Inicializar slider solutions
    var swiperSolutions = new Swiper('.slider-box-solutions', {
        spaceBetween: 32,
        slidesPerView: "auto",
        breakpoints: {
            1300: {
                initialSlide: 2,
                centeredSlides: true,
            }
        }
    });

    var swiperSolutions = new Swiper('.slider-box-solutions-not-infinity', {
        spaceBetween: 32,
        slidesPerView: 1,
        loop: true,
        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            750: {
                slidesPerView: 3
            }
        },
        navigation: {
            nextEl: '.slider-box-solutions-not-infinity-next',
            prevEl: '.slider-box-solutions-not-infinity-prev'
        },
    });

    var swiperInformation = new Swiper('.slider-box-information', {
        loop: true,
        spaceBetween: 32,
        slidesPerView: 1,
        navigation: {
            nextEl: '.slider-info-box-information-next',
            prevEl: '.slider-info-box-information-prev',
            disabledClass: 'disabled_swiper_button'
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },

            750: {
                slidesPerView: 1,
            },

            1200: {
                slidesPerView: 2,
            }
        }
    });
});


/* Link 'Ver más' descripción de producto */

document.addEventListener('DOMContentLoaded', function() {
    const descriptions = document.querySelectorAll('.product__description');
    const toggleLinks = document.querySelectorAll('.toggle-link');

    descriptions.forEach((description, index) => {
        const toggleLink = toggleLinks[index];

        function checkDescriptionHeight() {
            const lines = description.innerText.split("\n").length;
            if (lines > 15) {
                toggleLink.style.display = 'block';
            } else {
                toggleLink.style.display = 'none';
            }
        }

        toggleLink.addEventListener('click', function(e) {
            e.preventDefault();
            description.classList.toggle('expanded');
            if (description.classList.contains('expanded')) {
                toggleLink.innerText = 'Ver menos';
            } else {
                toggleLink.innerText = 'Ver más';
            }
        });

        checkDescriptionHeight();
    });
});
